(function () {

  'use strict';

  function pxPaginator($timeout) {
    return {
      restrict: 'EA',
      scope: {
        page: '=',
        pageSize: '=',
        totalPages: '=',
        onPaging: '&'
      },
      templateUrl: 'app/directives/paginator/paginator.template.html',
      link: function (scope) {

        scope.isFirstPage = function () {
          return scope.page === 0;
        };

        scope.isLastPage = function () {
          return scope.page === scope.totalPages - 1;
        };

        scope.getPreviousPage = function () {
          if (scope.page > 0) {
            scope.page--;
            onPaging();
          }
        };

        scope.getNextPage = function () {
          if (scope.page < scope.totalPages - 1) {
            scope.page++;
            onPaging();
          }
        };

        scope.getFirstPage = function () {
          if (scope.page !== 0) {
            scope.page = 0;
            onPaging();
          }
        };

        scope.getLastPage = function () {
          const lastPage = scope.totalPages - 1;
          if (scope.page !== lastPage) {
            scope.page = lastPage;
            onPaging();
          }
        };

        function onPaging() {
          $timeout(function () {
            scope.onPaging();
          });
        }

      }
    };
  }

  pxPaginator.$inject = ['$timeout'];

  angular
    .module('printix-admin')
    .directive('pxPaginator', pxPaginator);

})();
